import React from 'react';
import { Result, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useMsal } from '@azure/msal-react';
import { clearGoogleCredential } from '../api';

export default function AccountLockedPage() {
  const { instance } = useMsal();

  const handleSignOut = async () => {
    // Google sessions too, or a locked agent signs straight back in to this page.
    clearGoogleCredential();
    await instance.clearCache();
    window.location.replace(window.location.origin);
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f5f5f5' }}>
      <Result
        icon={<LockOutlined style={{ color: '#ff4d4f' }} />}
        status="error"
        title="Account Locked"
        subTitle="Your account has been locked. Please contact your administrator to regain access."
        extra={
          <Button type="primary" onClick={handleSignOut}>
            Sign Out
          </Button>
        }
      />
    </div>
  );
}
